import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import OrdersService from '@/services/resources/orders.service';

const List = () => import(/* webpackChunkName: "receipts" */ '@/views/Receipts/List.vue');
const Create = () => import(/* webpackChunkName: "receipts" */ '@/views/Receipts/Create.vue');
const Edit = () => import(/* webpackChunkName: "receipts" */ '@/views/Receipts/Edit.vue');
const Show = () => import(/* webpackChunkName: "receipts" */ '@/views/Receipts/Show.vue');
const OrderList = () => import(/* webpackChunkName: "receipts" */ '@/views/Receipts/OrderList.vue');
const Liquidate = () => import(/* webpackChunkName: "receipts" */ '@/views/Receipts/Liquidate.vue');
const LiquidationSeller = () => import(/* webpackChunkName: "receipts" */ '@/views/Receipts/LiquidationSeller.vue');
const LiquidationSellerLiquidated = () =>
  import(/* webpackChunkName: "receipts" */ '@/views/Receipts/LiquidationSellerLiquidated.vue');
const LiquidationDistributor = () =>
  import(/* webpackChunkName: "receipts" */ '@/views/Receipts/LiquidationDistributor.vue');
const LiquidationDistributorLiquidated = () =>
  import(/* webpackChunkName: "receipts" */ '@/views/Receipts/LiquidationDistributorLiquidated.vue');
const LiquidationDetail = () => import(/* webpackChunkName: "receipts" */ '@/views/Receipts/LiquidationDetail.vue');
const InvoiceForm = () => import(/* webpackChunkName: "receipts" */ '@/views/Receipts/Forms/InvoiceForm.vue');

let receiptsPages = {
  path: '/receipts',
  redirect: '/receipts/accepted-orders',
  component: DashboardLayout,
  name: 'Receipts',
  meta: {
    title: 'Recibos',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'ReceiptList',
      meta: {
        title: 'Lista de recibos',
        auth: ['payment_access.see_receipts'],
      },
      component: List,
    },
    {
      path: 'invoice-form',
      name: 'InvoiceLiquidationForm',
      meta: {
        title: 'Asociar factura',
        auth: ['receipts.store'],
      },
      component: InvoiceForm,
    },
    {
      path: 'liquidation-by-distributor-liquidated',
      name: 'LiquidationDistributorToLiquidate',
      meta: {
        title: 'Liquidación por distribuidor',
        auth: ['payment_access.see_distributor_settlements_to_be_invoiced'],
      },
      component: LiquidationDistributorLiquidated,
    },
    {
      path: 'liquidation-by-distributor',
      name: 'LiquidationDistributor',
      meta: {
        title: 'Liquidación por distribuidor',
        auth: ['payment_access.see_distributor_settlements'],
      },
      component: LiquidationDistributor,
    },
    {
      path: 'liquidation-by-seller-liquidated',
      name: 'LiquidationSellerToLiquidate',
      meta: {
        title: 'Liquidación por asesor',
        auth: ['payment_access.see_advisor_settlements_to_be_invoiced'],
      },
      component: LiquidationSellerLiquidated,
    },
    {
      path: 'liquidation-by-seller',
      name: 'SellerLiquidation',
      meta: {
        title: 'Liquidación por asesor',
        auth: ['payment_access.see_advisor_settlements'],
      },
      component: LiquidationSeller,
    },
    {
      path: 'liquidation-detail',
      name: 'LiquidationDetail',
      meta: {
        title: 'Detalle Liquidación',
        auth: ['receipts.index'],
      },
      component: LiquidationDetail,
    },
    {
      path: 'accepted-orders',
      name: 'ReceiptAcceptedOrders',
      meta: {
        title: 'Pedidos a cancelar',
        orderState: OrdersService._STATE_ACCEPTED,
        auth: ['payment_access.see_orders_to_cancel'],
      },
      component: OrderList,
    },
    {
      path: 'liquidation-orders',
      name: 'ReceiptToLiquidateOrders',
      meta: {
        title: 'Pedidos a liquidar',
        orderState: OrdersService._STATE_TO_LIQUIDATE,
        auth: ['payment_access.see_orders_to_be_settled'],
      },
      component: OrderList,
    },
    {
      path: 'create/:orderId',
      name: 'ReceiptCreate',
      meta: {
        title: 'Crear Recibo',
        auth: ['receipts.store'],
      },
      component: Create,
    },
    {
      path: 'edit/:receiptId',
      name: 'ReceiptEdit',
      meta: {
        title: 'Editar Recibo',
        auth: ['receipts.update'],
      },
      component: Edit,
    },
    {
      path: 'show/:receiptId',
      name: 'ReceiptShow',
      meta: {
        title: 'Mostrar Recibo',
        auth: ['receipts.update'],
      },
      component: Show,
    },
    {
      path: 'liquidate/:orderId',
      name: 'Liquidate',
      meta: {
        title: 'Liquidar',
        auth: ['receipts.index'],
      },
      component: Liquidate,
    },
  ],
};

export default receiptsPages;
